<ng-container *osnRerenderOnEvent="onLanguageChangeEvent$">
  <div
    class="short-details d-flex align-items-center w-100"
    [class.small]="size === 'small'"
    [class.large]="size === 'large'"
    [class.dark-text]="darkTextColor"
    data-testid="MovieDetailsPage.shortDetails"
  >
    <p *ngIf="releaseYear">{{ releaseYear }}</p>
    <div class="age-rate-badge">
      <p *ngIf="ageRate">{{ ageRateText }}</p>
    </div>
    <p *ngIf="showLength && lengthInSeconds">{{ lengthInSeconds | secondsToHour }}</p>
    <p *ngIf="numberOfSeasons">{{ numberOfSeasons }} {{ numberOfSeasons | i18nPlural: seasonPluralMapping | translate }}</p>
    <p *ngIf="numberOfEpisodes">{{ numberOfEpisodes }} {{ numberOfEpisodes | i18nPlural: episodePluralMapping | translate }}</p>
    <!-- TODO when to show these icons -->
    <svg-icon *ngIf="false" key="4-k" class="for-k-icon"></svg-icon>
    <svg-icon *ngIf="false" key="dolby-atmos" class="dolby-icon"></svg-icon>
    <p
      *ngIf="subtitleLanguages?.length"
      [matTooltip]="'PreviewOverlay_Tooltip_Subtitle' | translate: { subtitle: subtitleTooltipText }"
      matTooltipClass="custom-tooltip"
      class="audio-sub-badge"
    >
      {{ 'Detail_Subtitle_Label' | translate }}
    </p>
    <p
      *ngIf="audioLanguages?.length"
      [matTooltip]="'PreviewOverlay_Tooltip_Audio' | translate: { audio: audioTooltipText }"
      matTooltipClass="custom-tooltip"
      class="audio-sub-badge"
    >
      {{ 'Detail_Audio_Label' | translate }}
    </p>
  </div>
</ng-container>
